import { render, staticRenderFns } from "./organization-form.vue?vue&type=template&id=f91e6dd0&scoped=true"
import script from "./organization-form.vue?vue&type=script&lang=js"
export * from "./organization-form.vue?vue&type=script&lang=js"
import style0 from "./organization-form.vue?vue&type=style&index=0&id=f91e6dd0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91e6dd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f91e6dd0')) {
      api.createRecord('f91e6dd0', component.options)
    } else {
      api.reload('f91e6dd0', component.options)
    }
    module.hot.accept("./organization-form.vue?vue&type=template&id=f91e6dd0&scoped=true", function () {
      api.rerender('f91e6dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/organization/components/organization-form.vue"
export default component.exports